



import { useDispatch } from "react-redux";
import { menuToggle } from "../../features/toggle/toggleSlice";
import { useTranslation } from "react-i18next";
const MenuToggler = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation()

  // menu togggle handler
  const menuToggleHandler = () => {
    dispatch(menuToggle());
  };

  return (
    <div className="mb-4 ms-0 show-1023">
      <button
        onClick={menuToggleHandler}
        type="button"
        className="theme-btn toggle-filters">
        <span className="flaticon-menu-1"></span> {t('menu.smallMenu')}
      </button>
    </div>
  );
};

export default MenuToggler;
